import DownloadSprievodnyDokumentButton from './DownloadSprievodnyDokumentButton';

export default DownloadSprievodnyDokumentButton;
